import React, { useEffect, useRef, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import Footer from "src/components/common/Footer";
import RightStickyBtn from "src/components/common/RightStickyBtn";
import NavTabs from "./NavTabs";
import { Controller, useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";
import { Editor } from '@tinymce/tinymce-react';
import FormMaskedInput from "src/_common/components/form-elements/maskedInput/maskedInput";
import { useAppPetitionDetailsSelector } from "src/_common/hooks/selectors/petition/petitionSelector";
import { useAppPetitionApi } from "src/_common/hooks/api/petition/appPetitionApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useHistory, useParams } from "react-router";
import NavbarMain from "src/components/common/navbar/NavbarMain";
import { CRYPTO_SECRET_KEY, YES_NO_RADIO } from "src/_config";
import { useCommonApi } from "src/_common/hooks/api/common/appCommonApiHook";
import SweetAlert from "react-bootstrap-sweetalert";
import RadioInput from "src/_common/components/form-elements/radioinput/radioInput";
import MetaDecorator from "src/components/common/MetaDecorator";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

interface EditPetitionFormValues {
  mobile: string,
  title: string,
  headline: string,
  file: FileList,
  chipIn: string,
  email: string,
}

const editPetitionSchema = yup.object().shape({
  mobile: yup
    .string()
    .required('Mobile No is required'),
  title: yup
    .string()
    .required('Title is required'),
  headline: yup
    .string(),
  file: yup
    .mixed(),
  // .required('Title is required'),
  // chipIn: yup
  //   .string()
  //   .required('Chip In is required'),
  email: yup
    .string()
    .email('Email must be a valid email')
    .required('Email is required'),
})

const EditMyPetition = () => {

  const MAX_LEN = 100

  const { register, control, setValue, handleSubmit, errors } = useForm<EditPetitionFormValues>({
    resolver: yupResolver(editPetitionSchema),
    defaultValues: {
      mobile: '',
      title: '',
      headline: '',
      file: '',
      email: '',
    },
  })

  const [alert, setAlert] = useState<any>(null);
  const [imageDimensions, setImageDimensions] = useState({});
  const [selected, setSelected] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [countryErrorMessage, setCountryErrorMessage] = useState<string>('')
  const [imgSrc, setImgSrc] = useState<string>()
  const [imageFile, setImageFile] = useState<any>()
  const petitionDetails = useAppPetitionDetailsSelector();
  const petitionApi = useAppPetitionApi()
  const toast = useToaster()
  const editorRef: any = useRef(null);
  const {slug} = useParams<any>();
  // const id = parseInt(cryptr.decrypt(petitionId.id));
  // const slug = petitionId.slug;
  const history = useHistory()
  const commonApi = useCommonApi();
  const [count, setCount] = useState<number>(MAX_LEN*10)

  const onEditorChange = (e: any, editor:any) => {
    if (editor) {
      let editorContent = editor.getContent({format : 'text'})
      if(editorContent.length<=MAX_LEN*10) {
      //   console.log(editorRef?.current.getContent(),{e})
        changeCount(editorContent)
        setErrorMessage('')
      //   setData(e)
        // editor.setContent(e)
      }

      // if (editorContent == '')
      // {
      //   setErrorMessage("Story text is required")
      // }
      else
      {
        setCount(0)
        setErrorMessage('Character limit exceeded')
      }
    }
    // console.log({ e })
    // if (editorRef.current) {
    //   let editorContent = editorRef?.current.getContent()
    //   if (editorContent == '') {
    //     setErrorMessage("Story text is required")
    //   }
    //   else {
    //     setErrorMessage('')
    //   }
    // }
  }

  const changeCount = (e: any) => {
    let x = String(e)
    setCount(MAX_LEN*10 - x.length)
  }

  const handleImageRemoveClick = () => {
    setImgSrc('');
    setImageFile(null);
    if (petitionDetails.petition_image && petitionDetails.petition_image.id != 0) {
      let params = {
        entity_id: petitionDetails?.id,
        type: "petition"
      }
      commonApi.callDeleteImage(params, (message: string, resp: any) => {
        // console.log({ resp })
        toast.success(message)
        hideAlert()
      }, (message: string) => {
        toast.error(message)
      })
    } else {
      toast.success("Image has been successfully deleted.")
      hideAlert()
    }
  }

  const handleRemoveImage = (e: any) => {
    e.preventDefault()
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Delete!"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="primary"
        title="Remove Image"
        onConfirm={handleImageRemoveClick}
        onCancel={hideAlert}
        // focusCancelBtn
      >
        Are you sure to remove the Image?
      </SweetAlert>
    );
  }

  const hideAlert = () => {
    setAlert(null)
  }

  const loadImage = (setImageDimensions: any, imageUrl: any) => {
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      // console.log({height: img.height,width: img.width})
      setImageDimensions({
        height: img.height,
        width: img.width
      });
      if (img.width < 1000) {
        setImageFile(null)
        setImgSrc('')
        toast.error("Please select an image of minimum width 1000px...")
      }
    };
    img.onerror = (err) => {
      // console.log("img error");
      // console.error(err);
    };
  };

  const onImageChange = (e: any) => {
    // console.log(e.target.files[0])
    let file = e.target.files[0]
    let imgTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/svg", "image/svg+xml"]
    if (file && file.type && imgTypes.includes(file.type)) {
      setImageFile(e.target.files[0])
      setImgSrc(URL.createObjectURL(e.target.files[0]))
      loadImage(setImageDimensions, URL.createObjectURL(e.target.files[0]));
    }
    else if (file && file.type && !imgTypes.includes(file.type)) {
      toast.error("The image must be of type: jpeg, png, jpg, gif, svg")
    }
    else {
      toast.error("Please select only image file...")
    }
  }

  const getPetitionDetails = () => {
    const params = {
      slug,
    };
    petitionApi.callgetPetitionDetails(
      params,
      (message: string, resp: any) => {
        // console.log({ resp });
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const editPetition = (params: any) => {
    petitionApi.callEditPetition(params, (message: string, resp: any) => {
      // console.log({ resp })
      history.push(`/edit-petition/${slug}`);
      toast.success(message)
    }, (message: string) => {
      toast.error(message)
    })
  }

  const onSubmit = (values: any) => {
    console.log({ values })
    let fd = new FormData();
    let valid = true

    if (values) {
      fd.append("title", values.title)
      fd.append("sharing_headline", values.headline)
      // fd.append("country_id",values.country_id)
      // fd.append("phone_code",values.phone_code)
      fd.append("mobile", values.mobile)
      fd.append("email", values.email)
      if(isNaN(values.mobile)) {
        toast.error("Please enter valid mobile number")
        return
      }
      if (petitionDetails) {
        fd.append("petition_id", petitionDetails.id)
        // fd.append("category_id", petitionDetails.category_id)
        // fd.append("chip_in", values.chipIn)
        fd.append("chip_in", "1")
        fd.append("target_users", petitionDetails.target_users)
      }
      else {
        valid = false
      }
    }

    if (imageFile) {
      fd.append("image", imageFile)
    }

    if (editorRef.current) {
      let editorContent = editorRef?.current.getContent()
      if (editorContent == '')
      {
        valid = false
        setErrorMessage("Story text is required")
        editorRef?.current.focus()
      }
      else if(errorMessage!='') {
        valid = false
        editorRef?.current.focus()
      }
      else
      {
        fd.append("description", editorContent)
      }
      // let editorContent = editorRef?.current.getContent()
      // if (editorContent == '') {
      //   valid = false
      //   setErrorMessage("Story text is required")
      // }
      // else {
      //   fd.append("description", editorContent)
      // }
    }

    let x
    if (selected) {
      x = selected == "US" ? "231" : selected == "CA" ? "38" : ""
      fd.append("country_id", x)
      fd.append("phone_code", "1")
    }
    else {
      valid = false
      setCountryErrorMessage("Country selection is required")
    }

    if (valid) {
      editPetition(fd)
    }
  }

  useEffect(() => {
    // console.log({ petitionDetails })
    if (petitionDetails) {
      if (petitionDetails.petition_image) {
        if (petitionDetails.petition_image.id != 0) {
          setImgSrc(petitionDetails.petition_image.original);
        } else {
          setImgSrc('');
        }
      }
      if (petitionDetails.mobile) {
        setValue("mobile", petitionDetails.mobile)
      }
      if (petitionDetails.email) {
        setValue("email", petitionDetails.email)
      }
      if (petitionDetails.title) {
        setValue("title", petitionDetails.title)
      }
      if (petitionDetails.sharing_headline) {
        setValue("headline", petitionDetails.sharing_headline)
      }
      // let editorContent = editorRef?.current
      // if(petitionDetails.description && editorContent) {
      //   editorContent?.setContent(petitionDetails.description)
      // }
      if (petitionDetails.country_id) {
        setSelected(petitionDetails.country_id == "231" ? "US" : "CA")
      }
      // if (petitionDetails.chip_in) {
      //   setValue("chipIn", parseInt(petitionDetails.chip_in))
      // }
    }
  }, [petitionDetails, editorRef])

  useEffect(() => {
    getPetitionDetails()
  }, [])

  return (
    <>

      <MetaDecorator
        title={petitionDetails?.title+" : Edit"}
        description={petitionDetails?.title+" : Edit"}
        imageUrl={petitionDetails?.petition_image?.thumb}
      />
      
      {alert}
      <NavbarMain section={"petition"} />
      <div className="innerpageBanner nobanner_image"></div>
      <RightStickyBtn />

      {/* main section starts */}

      <section className="inner-page adjusted-padding-top">
        <div className="container">
          <div className="custom-tab-wrap">
            <NavTabs
              page={"edit"}
            // setPage={setPage}
            />
            <div className="tab-content">

              <div
                className="tab-pane show active"
                id="Edit"
                role="tabpanel"
                aria-labelledby="Edit-tab"
                tabIndex={0}
              >
                <div className="inner-tab-wrap">
                  <h2 className="tab-title">Edit your petition</h2>
                  <div className="edit-petition-wrap">
                    <div className="row">
                      <div className="col-sm-9">
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                          <div className="form-edit">
                            <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Phone number{" "}
                                <i style={{ color: 'red' }}>*</i>
                              </label>
                              <div className="row">
                                <div className="col-12">
                                  <div className="country-wrap">
                                    <ReactFlagsSelect
                                      selected={selected}
                                      className="react-select-wrap"
                                      onSelect={(code) => setSelected(code)}
                                      countries={["US", "CA"]}
                                      customLabels={{
                                        "US": { primary: "United States", secondary: "+1" },
                                        "CA": { primary: "Canada", secondary: "+1" },
                                      }}
                                    />
                                    {countryErrorMessage && countryErrorMessage.length && <div className="invalid-feedback">{countryErrorMessage}</div>}
                                    <Controller
                                      control={control}
                                      name="mobile"
                                      render={({ onChange, onBlur, value, name, ref }) => (
                                        // <FormTextInput
                                        //   name={name}
                                        //   className="form-control"
                                        //   onChange={onChange}
                                        //   onBlur={onBlur}
                                        //   value={value}
                                        //   maxLength={11}
                                        //   inputRef={ref}
                                        //   type="number"
                                        //   min={0}
                                        //   max={99999999999}
                                        //   error={errors.mobile}
                                        //   placeholder="Enter Mobile No Here..."
                                        // />
                                        <FormMaskedInput
                                          name={name}
                                          mask="9999999999"
                                          maskPlaceholder="1234567890"
                                          //   min={0}
                                          //   max={99999999999}
                                          onChange={onChange}
                                          onBlur={onBlur}
                                          value={value}
                                          inputRef={ref}
                                          type="tel"
                                          error={errors.mobile}
                                          placeholder="Enter Mobile No Here..."
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Email{" "}
                                <i style={{ color: 'red' }}>*</i>
                              </label>
                              <div className="row">
                                <div className="col-12">
                                  <Controller
                                    control={control}
                                    name="email"
                                    render={({ onChange, onBlur, value, name, ref }) => (
                                        <FormTextInput
                                            name={name}
                                            onChange={onChange}
                                            onBlur={onBlur}
                                            value={value}
                                            inputRef={ref}
                                            type="text"
                                            error={errors.email}
                                            placeholder="Enter Email Here..."
                                        />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Add a decision maker{" "}
                                <i
                                  className="fa fa-exclamation-circle"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="This is a Tooltip"
                                />
                              </label>
                              <input type="text" className="form-control" defaultValue="" />
                            </div> */}
                            <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Petition title{" "}
                                <i style={{ color: 'red' }}>*</i>
                              </label>
                              <Controller
                                control={control}
                                name="title"
                                render={({ onChange, onBlur, value, name, ref }) => (
                                  <FormTextInput
                                    name={name}
                                    onChange={e => {
                                      onChange(e)
                                      // changeCount(e)
                                    }}
                                    onBlur={onBlur}
                                    value={value}
                                    maxLength={MAX_LEN}
                                    inputRef={ref}
                                    type="text"
                                    error={errors.title}
                                    placeholder="Enter Petition Title Here..."
                                  />
                                )}
                              />
                            </div>
                            <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Headline for sharing{" "}
                              </label>
                              <Controller
                                control={control}
                                name="headline"
                                render={({ onChange, onBlur, value, name, ref }) => (
                                  <FormTextInput
                                    name={name}
                                    onChange={e => {
                                      onChange(e)
                                      // changeCount(e)
                                    }}
                                    onBlur={onBlur}
                                    value={value}
                                    inputRef={ref}
                                    type="text"
                                    error={errors.headline}
                                    placeholder="Enter Headline for Sharing Here..."
                                  />
                                )}
                              />
                            </div>
                            {/* <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Chip In{" "}
                                <i
                                  className="fa fa-exclamation-circle"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="This is a Tooltip"
                                />
                              </label>
                              <Controller
                                control={control}
                                name="chipIn"
                                render={({ onChange, onBlur, value, name, ref }) => (
                                  <RadioInput
                                    name={name}
                                    options={YES_NO_RADIO}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    inputRef={ref}
                                    error={errors.chipIn}
                                  />
                                )}
                              />
                            </div> */}
                            <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Explain the problem you want to solve{" "}
                                <i style={{ color: 'red' }}>*</i>
                              </label>
                              <Editor
                                apiKey="2utn329kvrgai26fg6qt532okdsdvy9m1lgfk4ss1jaytsu9"
                                onInit={(evt: any, editor: any) => {
                                  editorRef.current = editor
                                  if(petitionDetails && petitionDetails.description)
                                  {
                                    editor.setContent(petitionDetails.description)
                                  }
                                }}
                                initialValue={petitionDetails && petitionDetails.description ? petitionDetails.description : null}
                                onEditorChange={onEditorChange}
                                init={{
                                  height: 300,
                                  menubar: false,
                                  plugins: [
                                    'advlist autolink lists link image charmap print preview anchor',
                                    'searchreplace visualblocks code fullscreen',
                                    'insertdatetime media table paste code help wordcount'
                                  ],
                                  toolbar: 'undo redo | formatselect | ' +
                                    'bold italic underline | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help',
                                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                }}
                              />
                              <span className="count-letter">
                                <span>Remaining:</span> {count}
                              </span>
                              {errorMessage && errorMessage.length && <div className="invalid-feedback">{errorMessage}</div>}
                            </div>
                            <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Add a photo{" "}
                                <i
                                  className="fa fa-exclamation-circle"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="This is a Tooltip"
                                />
                              </label><br/>
                              <b>File types accepted :</b> '.jpeg', '.png', '.jpg', '.gif', '.svg' <b>Max size:</b> 5MB <b>Min image width :</b> 1000px
                              <div className="upload-btn-wrapper">
                                {imgSrc ?
                                  <>
                                    <a 
                                    className="remove-phhoto"
                                    onClick={(e) => handleRemoveImage(e)}
                                    // onClick={() => setImgSrc('')}
                                    >
                                      ✖
                                    </a>
                                    <img src={imgSrc} alt="" />
                                  </>
                                  :
                                  <button className="btn-upload">
                                    Upload a file
                                    <img
                                      src={"/images/upload.svg"}
                                      alt="upload"
                                    />
                                    <input type="file" name="file" ref={register} accept="image/*" onChange={onImageChange} />
                                  </button>}
                              </div>
                            </div>
                            <div className="two-btns-wrap">
                              <button className="btn btn-secondary cancelbtn w-100" onClick={() => history.push(`/my-petition-dashboard/${slug}`)}>
                                Cancel
                              </button>
                              <button type="submit" className="btn btn-primary w-100 savebtn">
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      {/* <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Petition letter{" "}
                                <i
                                  className="fa fa-exclamation-circle"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="This is a Tooltip"
                                />
                              </label>
                              <textarea
                                name="content"
                                id="editor2"
                                defaultValue={
                                  "                                                    <p>Dear President/ Board of trustee/ regent [Name],</p>\n                                                    <p>\n                                                        Climate change is accelerating. We are witnessing the increasing impacts of a warming planet more and more consistently; in this last year alone our country experienced record-breaking heat, droughts, and hurricanes, which impacted hundreds of thousands of people and cost our country hundreds of billions of dollars. Hurricane Sandy alone caused $50bn in damages. Experts agree that global warming caused by humans burning fossil fuels will continue to accelerate and intensify these tragic climate disasters. The scientific consensus is clear and overwhelming; we cannot safely burn even half of global fossil-fuel reserves without dangerously warming the planet for several thousand years.\n                                                    </p>\n                                                    <p>\n                                                        As public pressure to confront climate change builds, we call on [SCHOOL] to immediately freeze any new investment in fossil-fuel companies, and to divest within five years from direct ownership and from any commingled funds that include fossil-fuel public equities and corporate bonds. We believe such action on behalf of [School] will not only be a sound decision for our institution's financial portfolio, but also for the wellbeing of its current and future graduating classes, who deserve the opportunity to graduate with a future not defined by climate chaos.\n                                                    </p>\n                                                    <p>\n                                                        For the good of our students and our nation, and to preserve the quality of life for this and future generations worldwide, we call upon you to join a growing movement of schools around the country that are committed to preventing a more extreme climate by moving [School's] endowment beyond fossil fuels.\n                                                    </p>\n                                                    <p>Signed,</p>\n                                                    <p>XXX</p>\n                                                "
                                }
                              />
                            </div> */}
                      {/* <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Add a place{" "}
                                <i
                                  className="fa fa-exclamation-circle"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="This is a Tooltip"
                                />
                              </label>
                              <input type="text" className="form-control" defaultValue="" />
                            </div> */}
                      {/* <div className="mb-4">
                              <label htmlFor="" className="form-label">
                                Add topics{" "}
                                <i
                                  className="fa fa-exclamation-circle"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="This is a Tooltip"
                                />
                              </label>
                              <input type="text" className="form-control" defaultValue="" />
                            </div> */}
                      <div className="col-sm-3">
                        <div className="white-rounded-box mb-4">
                          <div className="white-box-header">Tips &amp; guides</div>
                          <div className="white-box-body">
                            <div className="edit-petition-help-list">
                              <ul>
                                <li>
                                  <a>Create your petition</a>
                                </li>
                                <li>
                                  <a>Share your petition</a>
                                </li>
                                <li>
                                  <a>Build momentum</a>
                                </li>
                                <li>
                                  <a>Reach out to the media</a>
                                </li>
                                <li>
                                  <a>Engage your decision maker</a>
                                </li>
                                <li>
                                  <a>Declare victory</a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* main section end */}

      <Footer />
    </>
  );
};

export default EditMyPetition;
